<template>
	<div class="home_container" :class="[isNewSkin ? 'home_container_bg_new' : 'home_container_bg']">
		<div class="header_container">
			<div class="logo">
				<img src="../assets/image/logo.png" alt />
			</div>
			<div class="centerBtn">
				<div class="RuleBtn" @click="activityRule()">
					<img :src="isNewSkin ? require('../assets/image/gameImages/button/activityRule.png') : require('../assets/image/button/activityRule.png')" alt />
				</div>
			</div>
			<div class="rightBtn">
				<div class="myGiftBtn" @click="myGiftBtn()">
					<img :src="isNewSkin ? require('../assets/image/gameImages/button/myGift.png') : require('../assets/image/button/myGift.png')" alt />
				</div>
			</div>
			<div class="rightIcon"></div>
		</div>
		<div class="content_container">
			<div class="content_box" :class="[isNewSkin ? 'content_box_bg_new' : 'content_box_bg']">
				<!-- 恭喜获得： -->
				<div class="youGet">
					<img src="../assets/image/youGet.png" />
				</div>
				<!-- 0:优惠卷 1:实体 type -->
				<!-- 优惠券卡包： -->
				<div v-if="giftInfo.type === 0">
					<!-- <div> -->
					<div class="input_box c_w">
						<div class="textBox f_15">{{ giftInfo.giftName }}</div>
					</div>
					<div class="whatTimeUse"></div>
					<div class="giftOneBox">
						<img :src="giftInfo.img" alt />
					</div>
					<div class="box55" style="margin-top: 5px;">
						<van-row>
							<van-col span="24" class="t_ac c_w f_12">奖券一自动放入【我的卡包】中</van-col>
						</van-row>
						<van-row>
							<van-col span="24" class="t_ac c_w f_12">点击【我的奖品】可查询查看路径</van-col>
						</van-row>
					</div>
					<!-- <div class="box80">
            <van-row>
              <van-col span="11" class="t_ac c_w f_12" @click="addCardBtn()">
                <img src="../assets/image/button/addCard.png" />
              </van-col>
              <van-col span="2"></van-col>
              <van-col span="11" class="t_ac c_w f_12" @click="laterToReceiveBtn()">
                <img src="../assets/image/button/LaterToReceive.png" alt />
              </van-col>
            </van-row>
          </div> -->
					<div class="look_list_now" :class="[isNewSkin ? 'look_list_now_bg_new' : 'look_list_now_bg']" @click="laterToReceiveBtn()">
						查看卡包
					</div>
				</div>
				<!-- 实体卡包： -->
				<div v-if="giftInfo.type === 1">
					<!-- <div> -->
					<div class="input_box02 c_w">
						<div class="textBox f_17">{{ giftInfo.giftName }}</div>
					</div>
					<div class="giftOneBox02">
						<img :src="giftInfo.img" alt />
					</div>
					<div class="getBtnButtom" @click="confirmGetBtn">
						<img :src="isNewSkin ? require('../assets/image/gameImages/button/getBtnButton.png') : require('../assets/image/button/getBtnButton.png')" alt />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios';
import {Dialog, Toast} from 'vant';
export default {
	data() {
		return {
			giftInfo: {},
			callbackInfo: {},
			addCardBtnFlag: false,
      isNewSkin: false, // 是否新皮肤
		};
	},
	computed: {
		userInfo02: function() {
			return this.$store.getters.getInfo02;
		},
	},
	methods: {
		activityRule() {
			this.$router.push({ name: 'activityRule' });
		},
		myGiftBtn() {
			this.$router.push({ name: 'myGiftAll' });
		},
		async addCardBtn() {
			if (this.addCardBtnFlag) {
				return;
			}
			this.addCardBtnFlag = true;
			const toastLoading = Toast.loading({
				message: '正在加入卡包',
				forbidClick: true,
				duration: 0,
			});
			try {
				let { data: result } = await this.$post(`/consumer/mkt-activity/addCoupon?callbackUUId=${this.callbackInfo.luckyUuid}`);
				if (result.code !== 200) {
					this.addCardBtnFlag = false;
					return Toast(result.errMsg);
				}
				this.addCardBtnFlag = false;
				toastLoading.clear();
				Toast('加入卡包成功');
				setTimeout(() => {
					this.$router.replace({ name: 'myGiftAll' });
				}, 500);
			} catch (err) {
				console.log(err);
			}
		},
		laterToReceiveBtn() {
			this.$Sensors.track('LuckydrawHomePageClick', {
				button_name: '查看卡包',
				cellphone: '',
				available: '',
			});


			this.$router.push({ name: 'myGiftAll' });
		},
    async confirmGetBtn() {
      let orderId = this.$store.getters.getInfo.orderId;
      try {
        let params = {
          orderNo: orderId,
        };
        let { data: result } = await this.$get('checkWriteAddress', params);
        if (result.code !== 200) {
          //   return Toast(result.errMsg);
          Dialog.alert({
            message: result.errMsg,
            confirmButtonText: "我知道了"
          }).then(() => {
            // on close
          });
          return
        } else {
          this.$router.push({
            name: 'address',
            query: { uid: this.callbackInfo.luckyUuid, orderNo: orderId },
          });
        }
      } catch (err) {
        console.log(err);
      }
		},
		// 抽奖：
		async luckDraw() {
			if (!this.userInfo02) return Toast('获取用户信息失败，暂无法抽奖');
			const toastLoading = Toast.loading({
				message: '正在加载',
				forbidClick: true,
				duration: 0,
			});
			let params = {
				luckActId: this.userInfo02.luckActId,
				param: this.userInfo02.param,
			};
			try {
				let { data: result } = await this.$get('luckDraw', params);
				if (result.code !== 200) {
					toastLoading.clear();
					Toast(result.errMsg);
					return;
				}
				toastLoading.clear();
				this.giftInfo = result.data.gift;
				this.callbackInfo = result.data.callback;
				this.$store.commit('LONIN_SET', this.callbackInfo);
			} catch (err) {
				console.log(err);
			}
		},
	},
	created() {
		this.luckDraw();
    this.isNewSkin = sessionStorage.getItem('isNewSkin') ? true : false;
	},
  beforeCreate() {
		document.title = '抽奖';
	},
};
</script>

<style lang="scss">
.van-dialog__confirm, .van-dialog__confirm:active {
  color: #1989fa !important;
  background-color: white !important;
}
.van-dialog__message {
  font-weight: normal !important;
}
</style>

<style lang="scss" scoped>
/deep/.van-cell {
	width: 100%;
	height: 100%;
	background-color: #dcf6ff;
	line-height: 35px;
	padding-top: 0px;
	padding-bottom: 0px;
}
.home_container {
	width: 100%;
	height: 100%;
	padding-top: 20px;
	// background-image: url('../assets/image/bgc01.png');
	background-size: 100% 100%;
	.header_container {
		width: 100%;
		height: 60px;
		display: flex;
		.logo {
			flex: 3;
			padding-left: 15px;
			img {
				width: 100%;
			}
		}
		.centerBtn {
			flex: 2;
			padding-left: 20px;
			.RuleBtn {
				width: 90%;
				height: 100%;
				img {
					width: 100%;
				}
			}
		}
		.rightBtn {
			flex: 2;
			padding-left: 10px;
			.myGiftBtn {
				width: 90%;
				height: 100%;
				img {
					width: 100%;
				}
			}
		}
		.rightIcon {
			width: 20px;
			padding-left: 10px;
			padding-top: 5px;
			img {
				width: 50%;
			}
		}
	}
	.content_container {
		margin-top: 30px;
		width: 100%;
		height: 500px;
		.content_box {
			width: 370px;
			height: 100%;
			margin: 0 auto;
			// background-image: url(../assets/image/redBgc04.png);
			background-size: cover;
			padding-top: 90px;
			.youGet {
				width: 27%;
				height: 35px;
				margin: 0 auto;
				img {
					width: 100%;
				}
			}
			.input_box,
			.input_box02 {
				width: 55%;
				height: 55px;
				margin: 0 auto;
				background-image: url(../assets/image/input/youGetOne.png);
				background-size: 100% 100%;
				.textBox {
					width: 100%;
					height: 100%;
					padding: 0px 10px;
					text-align: center;
					// background-color: red;
					font-weight: bold;
					display: flex;
					justify-content: center; /*水平居中对齐*/
					align-items: center;
				}
			}
			.input_box02 {
				height: 55px;
				margin-bottom: 20px;
			}
			.whatTimeUse {
				width: 40%;
				height: 20px;
				margin: 0 auto;
				font-size: 18px;
				text-align: center;
				color: #fff;
			}
			.giftOneBox {
				// width: 55%;
				width: 150px;
				height: 150px;
				// margin-left: 90px;
				margin: 0 auto;
				img {
					width: 100%;
					height: 100%;
				}
			}
			.giftOneBox02 {
				// width: 55%;
				width: 150px;
				height: 150px;
				// margin-left: 90px;
				margin: 0 auto;
				img {
					width: 100%;
					height: 100%;
				}
			}
			.getBtnButtom {
				width: 45%;
				margin: 0 auto;
				margin-top: 25px;
				img {
					width: 100%;
				}
			}
			.box55 {
				width: 55%;
				min-height: 30px;
				margin: 0 auto;
				margin-bottom: 20px;
			}
			.box80 {
				width: 65%;
				margin: 0 auto;
				img {
					width: 100%;
				}
			}
		}
    .content_box_bg {
      // 旧背景路径
      background-image: url('../assets/image/redBgc04.png');
    }
    .content_box_bg_new {
      // 新背景路径
      background-image: url('../assets/image/gameImages/redBgc04.png');  
    }
	}
}
.home_container_bg {
  // 旧背景路径
	background-image: url('../assets/image/bgc01.png');
}
.home_container_bg_new {
  // 新背景路径
  background-image: url('../assets/image/gameImages/bgc01.png');
}

.look_list_now {
	width: 40%;
	height: 45px;
	margin: 0 auto;
	background-size: 100% 100%;
	color: #fff;
	font-weight: bold;
	text-align: center;
	line-height: 45px;
	font-size: 14px;
}
.look_list_now_bg {
  // 旧按钮路径
	background-image: url('../assets/image/onlyBtn.png');
}
.look_list_now_bg_new {
  // 新按钮路径
  background-image: url('../assets/image/gameImages/onlyBtn.png');
}
</style>
